import React, { useMemo, useContext, useState } from "react";
import { useHistory } from "react-router-dom";
import { IonContent, IonPage } from "@ionic/react";
import { WerkerSchedulerHeader } from "../components/WerkHeader";
import CalendarViewMobile from "../components/CalendarViewMobile";
import { SchedJobContext } from "../context/JobContextScheduler";
import { WerkerJobContext } from "../context/JobContextWerker";
import { ProfileContext } from "../context/ProfileContext";
import { CalendarJobResource, schedJobsToEvents, werkerJobsToEvents } from "../utils/calendarUtils";
import "../theme/AppStyles.css";

const CalendarMobile: React.FC = () => {
  const history = useHistory();
  const { profile } = useContext(ProfileContext);
  const { schedJob } = useContext(SchedJobContext);
  const { werkerJob, invitedFeedJobs } = useContext(WerkerJobContext);
  const [calendarLabel, setCalendarLabel] = useState("");

  const isScheduler = profile?.UserLastRoleScheduler === true;

  const events = useMemo(() => {
    if (isScheduler) {
      return schedJobsToEvents(schedJob ?? []);
    }
    const combined = [...(invitedFeedJobs ?? []), ...(werkerJob ?? [])];
    return werkerJobsToEvents(combined);
  }, [isScheduler, schedJob, werkerJob, invitedFeedJobs]);

  const handleSelectJob = (resource: CalendarJobResource) => {
    if (resource.role === "scheduler") {
      history.push(`/SchedShiftDetail/${resource.firestoreDocId}`);
    } else {
      history.push(`/ShiftDetails/${resource.firestoreDocId}/${resource.jobDocId}/${resource.schedUid ?? ""}`);
    }
  };

  return (
    <IonPage>
      <WerkerSchedulerHeader title="WerkApp" forceShowBack={true} />
      <IonContent scrollY={false}>
        <CalendarViewMobile
          events={events}
          onSelectJob={handleSelectJob}
          isScheduler={isScheduler}
          onLabelChange={setCalendarLabel}
        />
      </IonContent>
    </IonPage>
  );
};

export default CalendarMobile;
